<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class="ms-4"
        dot
        data-testid="main-user-menu"
      >
        <v-avatar
          size="40px"
          v-bind="attrs"
          color="primary"
          class="v-avatar-light-bg primary--text"
          v-on="on"
        >
          <v-img
            v-if="userData.avatar"
            :src="userData.avatar"
          ></v-img>
          <v-icon
            v-else
            color="primary"
            size="28"
          >
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-avatar>
      </v-badge>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar
            size="40px"
            color="primary"
            class="v-avatar-light-bg primary--text"
          >
            <v-img
              v-if="userData.avatar"
              src="@/assets/images/avatars/1.png"
            ></v-img>
            <v-icon
              v-else
              color="primary"
              size="28"
            >
              {{ icons.mdiAccountOutline }}
            </v-icon>
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align:middle"
        >
          <span
            class="text--primary font-weight-semibold mb-n1"
            data-testid="main-user-menu-name"
          >
            {{ userData.last_name }}
          </span>
        </div>
      </div>
      <v-divider class="my-2"></v-divider>
      <v-list-item
        data-testid="main-user-menu-logout"
        @click="logoutUser"
      >
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiAccountOutline, mdiLogoutVariant } from '@mdi/js';
import { useNamespacedGetters } from 'vuex-composition-helpers';
import { useRouter } from '@core/utils';
import { getCurrentInstance } from '@vue/composition-api';
import { initialAbility } from '@/plugins/acl/config';
import { logout } from '@/services/user/auth.services';

export default {
  setup() {
    const vm = getCurrentInstance().proxy;
    const { router } = useRouter();

    const { getCurrentUser } = useNamespacedGetters(
      'userStore', ['getCurrentUser'],
    );
    const userData = getCurrentUser.value;
    const logoutUser = () => {
      logout();

      // Reset ability
      vm.$ability.update(initialAbility);

      // Redirect to login page
      router.push({ name: 'auth-login' });
    };

    return {
      logoutUser,
      userData,

      icons: {
        mdiAccountOutline,
        mdiLogoutVariant,
      },
    };
  },
};
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
